window.addEventListener("load", () => {

  $(document).on('mouseenter', '.nav-item.dropdown.dropdown-dimmer', function(){
    $('#dimmer').addClass('active')
  })
  $(document).on('mouseleave', '.nav-item.dropdown.dropdown-dimmer', function(){
    $('#dimmer').removeClass('active')
  })

});